import React__default from 'react';
import { FlagFR } from './FlagFR.js';
import { FlagUS } from './FlagUS.js';
import { FlagCN } from './FlagCN.js';

const Flag = (props) => {
    switch (props.country) {
        case 'fr':
            return React__default.createElement(FlagFR, { width: props.width, height: props.height });
        case 'us':
            return React__default.createElement(FlagUS, { width: props.width, height: props.height });
        case 'cn':
            return React__default.createElement(FlagCN, { width: props.width, height: props.height });
        default:
            return React__default.createElement(FlagFR, { width: props.width, height: props.height });
    }
};

export { Flag };
